import {
  getReq,
  postReq,
  deleteSendReq,
  putReq,
  getCPHeaderMap,
  getHeaderCodeMap,
  END_POINTS
} from '@/api'
import * as Utils from '@/utils'

// const baseUrl = process.env.BASE_URL

const state = {
  projAcctPayEntityList: [],
  projAcctPayEntityInfo: {
    entityId: '',
    projId: '',
    entityName: '',
    entityDesc: '',
    ctrAcctId: '',
    colId: '',
    entityContact: '',
    content: '',
    compId: '',
    colType: '',
    seq: 0,
    contractNo: '',
    status: '',
    entityStatus: '',
    lockBy: '',
    lockOn: new Date(0),
    crtBy: '',
    crtOn: new Date(0),
    updBy: '',
    updOn: new Date(0),
    //
    indUsed: ''
  },
  editIndex: -1,
  editAction: '',
  END_STATE: null
}

const getters = {

}

const actions = {
  async insertProjAcctPayEntity({
    dispatch,
    commit,
    state
  }, {projId, compId, codeParam}) {
    // debugger
    const insertObj = await postReq(END_POINTS.INSERT_RSP_PROJ_ACCT_PAY_ENTITY, {
      data: {
        entityName: state.projAcctPayEntityInfo.entityName,
        ctrAcctId: state.projAcctPayEntityInfo.ctrAcctId,
        entityContact: state.projAcctPayEntityInfo.entityContact,
        content: state.projAcctPayEntityInfo.content,
        contractNo: state.projAcctPayEntityInfo.contractNo,
        // status: state.projAcctPayEntityInfo.status,
        //
        projId: projId,
        compId: compId
      },
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return insertObj
  },
  async updateProjAcctPayEntityKeyInfo({
    dispatch,
    commit,
    state
  }, {entityId, projId, compId, codeParam}) {
    // debugger
    let projAcctPayEntityInfo = {
      entityName: state.projAcctPayEntityInfo.entityName,
      ctrAcctId: state.projAcctPayEntityInfo.ctrAcctId,
      // entityContact: state.projAcctPayEntityInfo.entityContact,
      // content: state.projAcctPayEntityInfo.content,
      // contractNo: state.projAcctPayEntityInfo.contractNo,
      // status: state.projAcctPayEntityInfo.status,
      //
      key: {
        entityId: entityId,
        projId: projId,
        compId: compId
      }
    }
    const updateObject = await putReq(END_POINTS.UPDATE_RSP_PROJ_ACCT_PAY_ENTITY_KEY_INFO, {
      data: projAcctPayEntityInfo,
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return updateObject
  },
  async updateProjAcctPayEntity({
    dispatch,
    commit,
    state
  }, {entityId, projId, compId, codeParam}) {
    let projAcctPayEntityInfo = {
      entityName: state.projAcctPayEntityInfo.entityName,
      ctrAcctId: state.projAcctPayEntityInfo.ctrAcctId,
      entityContact: state.projAcctPayEntityInfo.entityContact,
      content: state.projAcctPayEntityInfo.content,
      contractNo: state.projAcctPayEntityInfo.contractNo,
      // status: state.projAcctPayEntityInfo.status,
      //
      key: {
        entityId: entityId,
        projId: projId,
        compId: compId
      }
    }
    const updateObject = await putReq(END_POINTS.UPDATE_RSP_PROJ_ACCT_PAY_ENTITY, {
      data: projAcctPayEntityInfo,
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return updateObject
  },
  async removeProjAcctPayEntity({
    commit,
    state
  }, {entityId, projId, compId, codeParam}) {
    const deleteObject = await deleteSendReq(END_POINTS.REMOVE_RSP_PROJ_ACCT_PAY_ENTITY + `?entityId=${entityId}&projId=${projId}&compId=${compId}`, {
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return deleteObject
  },
  async findProjAcctPayEntity({
    commit
  }, {entityId, projId, compId, codeParam}) {
    const responseData = await getReq(END_POINTS.FIND_RSP_PROJ_ACCT_PAY_ENTITY + `?entityId=${entityId}&projId=${projId}&compId=${compId}`, {
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    if (responseData.success) {
      commit('updateProjAcctPayEntityInfo', responseData.data)
    } else {
      commit('updateProjAcctPayEntityInfo', {})
    }
  },
  async findProjAcctPayEntityList({
    commit,
    state,
    rootState
  }, { projId, compId, codeParam }) {
    const response = await getReq(END_POINTS.FIND_RSP_PROJ_ACCT_PAY_ENTITY_LIST + `?projId=${projId}&compId=${compId}`, {
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    commit('updateProjAcctPayEntityList', response)
  },
  async findProjAcctPayEntityStatisticList({
    commit,
    state,
    rootState
  }, { projId, compId, searchedForm, codeParam }) {
    // let searchedForm = state.searchedForm || state.emptySearchInfo
    let data = {
      projId,
      compId,
      // entityName: searchedForm.searchEntityName,
      searchType: searchedForm.searchType,
      searchMonth: new Date(Utils.getMonthFirstDay(searchedForm.searchMonth)).getTime(),
      searchMonthType: searchedForm.searchMonthType,
      startDt: new Date(searchedForm.searchStartDt).getTime(),
      endDt: new Date(searchedForm.searchEndDt).getTime()
    }
    const response = await postReq(END_POINTS.FIND_RSP_PROJ_ACCT_PAY_ENTITY_STATISTIC_LIST, {
      data,
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    commit('updateProjAcctPayEntityList', response)
  },
  END_ACTIONS() {}
}

const mutations = {
  updateProjId(state, value) {
    state.projAcctPayEntityInfo.projId = value
  },
  updateEntityId(state, value) {
    state.projAcctPayEntityInfo.entityId = value
  },
  updateEntityName(state, value) {
    state.projAcctPayEntityInfo.entityName = value
  },
  updateEntityDesc(state, value) {
    state.projAcctPayEntityInfo.entityDesc = value
  },
  updateCtrAcctId(state, value) {
    state.projAcctPayEntityInfo.ctrAcctId = value
  },
  updateColId(state, value) {
    state.projAcctPayEntityInfo.colId = value
  },
  updateEntityContact(state, value) {
    state.projAcctPayEntityInfo.entityContact = value
  },
  updateContent(state, value) {
    state.projAcctPayEntityInfo.content = value
  },
  updateCompId(state, value) {
    state.projAcctPayEntityInfo.compId = value
  },
  updateColType(state, value) {
    state.projAcctPayEntityInfo.colType = value
  },
  updateSeq(state, value) {
    state.projAcctPayEntityInfo.seq = value
  },
  updateContractNo(state, value) {
    state.projAcctPayEntityInfo.contractNo = value
  },
  updateStatus(state, value) {
    state.projAcctPayEntityInfo.status = value
  },
  updateEntityStatus(state, value) {
    state.projAcctPayEntityInfo.entityStatus = value
  },
  updateLockBy(state, value) {
    state.projAcctPayEntityInfo.lockBy = value
  },
  updateLockOn(state, value) {
    state.projAcctPayEntityInfo.lockOn = value
  },
  updateCrtBy(state, value) {
    state.projAcctPayEntityInfo.crtBy = value
  },
  updateCrtOn(state, value) {
    state.projAcctPayEntityInfo.crtOn = value
  },
  updateUpdBy(state, value) {
    state.projAcctPayEntityInfo.updBy = value
  },
  updateUpdOn(state, value) {
    state.projAcctPayEntityInfo.updOn = value
  },
  updateProjAcctPayEntityList(state, response) {
    if (response.success === true && response.data.length) {
      state.projAcctPayEntityList = response.data
    } else {
      state.projAcctPayEntityList = []
    }
  },
  updateProjAcctPayEntityListEmpty(state) {
    state.editIndex = -1
    state.projAcctPayEntityList = []
  },
  updateProjAcctPayEntityEmpty(state) {
    state.projAcctPayEntityInfo.projId = ''
    state.projAcctPayEntityInfo.entityId = ''
    state.projAcctPayEntityInfo.entityName = ''
    state.projAcctPayEntityInfo.entityDesc = ''
    state.projAcctPayEntityInfo.ctrAcctId = ''
    state.projAcctPayEntityInfo.colId = ''
    state.projAcctPayEntityInfo.entityContact = ''
    state.projAcctPayEntityInfo.content = ''
    state.projAcctPayEntityInfo.compId = ''
    state.projAcctPayEntityInfo.colType = ''
    state.projAcctPayEntityInfo.seq = 0
    state.projAcctPayEntityInfo.contractNo = ''
    state.projAcctPayEntityInfo.status = ''
    state.projAcctPayEntityInfo.entityStatus = ''
    state.projAcctPayEntityInfo.lockBy = ''
    state.projAcctPayEntityInfo.lockOn = new Date(0)
    state.projAcctPayEntityInfo.crtBy = ''
    state.projAcctPayEntityInfo.crtOn = new Date(0)
    state.projAcctPayEntityInfo.updBy = ''
    state.projAcctPayEntityInfo.updOn = new Date(0)

    state.projAcctPayEntityInfo.indUsed = ''
  },
  updateProjAcctPayEntityInfo(state, projAcctPayEntityInfo) {
    // debugger
    state.projAcctPayEntityInfo.projId = projAcctPayEntityInfo.projId
    state.projAcctPayEntityInfo.entityId = projAcctPayEntityInfo.entityId
    state.projAcctPayEntityInfo.entityName = projAcctPayEntityInfo.entityName
    state.projAcctPayEntityInfo.entityDesc = projAcctPayEntityInfo.entityDesc
    state.projAcctPayEntityInfo.ctrAcctId = projAcctPayEntityInfo.ctrAcctId
    state.projAcctPayEntityInfo.colId = projAcctPayEntityInfo.colId
    state.projAcctPayEntityInfo.entityContact = projAcctPayEntityInfo.entityContact
    state.projAcctPayEntityInfo.content = projAcctPayEntityInfo.content
    state.projAcctPayEntityInfo.compId = projAcctPayEntityInfo.compId
    state.projAcctPayEntityInfo.colType = projAcctPayEntityInfo.colType
    state.projAcctPayEntityInfo.seq = projAcctPayEntityInfo.seq
    state.projAcctPayEntityInfo.contractNo = projAcctPayEntityInfo.contractNo
    state.projAcctPayEntityInfo.status = projAcctPayEntityInfo.status
    state.projAcctPayEntityInfo.entityStatus = projAcctPayEntityInfo.entityStatus
    state.projAcctPayEntityInfo.lockBy = projAcctPayEntityInfo.lockBy
    state.projAcctPayEntityInfo.lockOn = projAcctPayEntityInfo.lockOn
    state.projAcctPayEntityInfo.crtBy = projAcctPayEntityInfo.crtBy
    state.projAcctPayEntityInfo.crtOn = projAcctPayEntityInfo.crtOn
    state.projAcctPayEntityInfo.updBy = projAcctPayEntityInfo.updBy
    state.projAcctPayEntityInfo.updOn = projAcctPayEntityInfo.updOn
    //
    state.projAcctPayEntityInfo.indUsed = projAcctPayEntityInfo.indUsed
  },
  updateEditIndex(state, value) {
    state.editIndex = value
  },
  updateEditAction(state, value) {
    state.editAction = value
  },
  // newEmptyRowObj() {
  //   return {
  //     ctrAcctId: '',
  //     type: '',
  //     indUsed: '',
  //     status: ''
  //   }
  // },
  appendBottomRow() {
    this.commit('confProjAcctPayEntityManage/updateProjAcctPayEntityEmpty')
    let obj = {...state.projAcctPayEntityInfo}
    // debugger
    obj.isBottomRow = true
    state.projAcctPayEntityList.push(obj)
  },
  handleAdd(state, {row, index, ctrAcctId}) {
    // debugger
    this.commit('confProjAcctPayEntityManage/updateProjAcctPayEntityEmpty')
    this.commit('confProjAcctPayEntityManage/updateEditIndex', index)
    this.commit('confProjAcctPayEntityManage/updateEditAction', 'insert')
    //
    this.commit('confProjAcctPayEntityManage/updateCtrAcctId', ctrAcctId)
  },
  handleEdit(state, {row, index}) {
    // debugger
    this.commit('confProjAcctPayEntityManage/updateProjAcctPayEntityInfo', row)
    this.commit('confProjAcctPayEntityManage/updateEditIndex', index)
    this.commit('confProjAcctPayEntityManage/updateEditAction', 'update')
  },
  END_MUTATIONS() {}
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/proj/project/confProjAcctPayEntityManage.js